import { Link } from 'react-router-dom';

const footerLinks = {
  product: {
    title: '产品',
    links: [
      { label: '豆花视频APP', path: '#download' },
      { label: '豆花视频TV版', path: '#' },
      { label: '豆花视频网页版', path: '#' },
      { label: '功能更新日志', path: '#' },
    ],
  },
  content: {
    title: '内容',
    links: [
      { label: '热门影视', path: '/category/drama' },
      { label: '综艺节目', path: '/category/variety' },
      { label: '短视频', path: '/category/short-video' },
      { label: '纪录片', path: '/category/documentary' },
    ],
  },
  support: {
    title: '支持',
    links: [
      { label: '帮助中心', path: '#' },
      { label: '反馈建议', path: '#' },
      { label: '服务协议', path: '#' },
      { label: '隐私政策', path: '#' },
    ],
  },
  about: {
    title: '关于',
    links: [
      { label: '品牌介绍', path: '/about' },
      { label: '联系我们', path: '/about#contact' },
      { label: '加入我们', path: '#' },
      { label: '合作洽谈', path: '#' },
    ],
  },
};

export default function Footer() {
  return (
    <footer className="bg-background-900 text-foreground-100">
      {/* Main Footer */}
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8">
          {/* Brand Column */}
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-play-circle-fill text-xl text-white"></i>
              </div>
              <span className="text-xl font-heading font-bold text-white">
                豆花视频
              </span>
            </Link>
            <p className="text-sm text-foreground-400 leading-relaxed mb-4">
              致力于为用户提供正版高清视频内容，涵盖影视、综艺、短视频等多种类型，打造舒适流畅的观影体验。
            </p>
            <div className="flex gap-3">
              <a href="#" className="w-8 h-8 rounded-lg bg-foreground-700 hover:bg-primary-500 flex items-center justify-center transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-sm text-white"></i>
              </a>
              <a href="#" className="w-8 h-8 rounded-lg bg-foreground-700 hover:bg-primary-500 flex items-center justify-center transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-sm text-white"></i>
              </a>
              <a href="#" className="w-8 h-8 rounded-lg bg-foreground-700 hover:bg-primary-500 flex items-center justify-center transition-colors cursor-pointer" aria-label="抖音">
                <i className="ri-tiktok-line text-sm text-white"></i>
              </a>
              <a href="#" className="w-8 h-8 rounded-lg bg-foreground-700 hover:bg-primary-500 flex items-center justify-center transition-colors cursor-pointer" aria-label="哔哩哔哩">
                <i className="ri-bilibili-line text-sm text-white"></i>
              </a>
            </div>
          </div>

          {/* Link Columns */}
          {Object.values(footerLinks).map((section) => (
            <div key={section.title}>
              <h4 className="text-sm font-semibold text-white mb-4">{section.title}</h4>
              <ul className="space-y-2.5">
                {section.links.map((link) => (
                  <li key={link.label}>
                    {link.path.startsWith('/') ? (
                      <Link
                        to={link.path}
                        className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                      >
                        {link.label}
                      </Link>
                    ) : (
                      <a
                        href={link.path}
                        className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                      >
                        {link.label}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-foreground-700/40">
        <div className="w-full px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 豆花视频 版权所有 | 京ICP备XXXXXXXX号-1 | 京网文[2024]XXXX-XXX号
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer">服务协议</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}